import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-style-guide',
    templateUrl: './style-guide.component.html',
    styleUrls: ['./style-guide.component.css'],
    standalone: false
})
export class StyleGuideComponent implements OnInit {

  title = '';
  dateTimeExample: any;
  constructor() { }

  ngOnInit() {
  }

  dateTime($e) {
    console.log(this.dateTimeExample);
    console.log('==========================');
    console.log($e);
  }

}
